import { render } from "./TabContent.vue?vue&type=template&id=694fdb43&scoped=true"
import script from "./TabContent.vue?vue&type=script&lang=js"
export * from "./TabContent.vue?vue&type=script&lang=js"

import "./TabContent.vue?vue&type=style&index=0&id=694fdb43&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src5135303/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694fdb43"]])

export default __exports__